import { isSprinkler, sprayR, sprayArc } from '../lib/spray';
import { isHead, headFlow } from '../lib/irrigation';

// throw radius, arc and direction of one sprinkler (object sheet)
const f1 = (v) => (Math.round(v * 10) / 10).toString().replace('.', ',');
function HeadExtra({ t, obj, patch, zones }) {
  return (
    <div className="spray-fields" data-testid="head-fields">
      <label>{t.izFlow}<input inputMode="decimal" data-testid="head-flow-input" value={obj.flow ?? ''} placeholder={f1(headFlow({ ...obj, flow: null }))} onChange={(e) => patch({ flow: e.target.value })} /></label>
      <label>{t.izZone}<select data-testid="head-zone-select" value={obj.zone || ''} onChange={(e) => patch({ zone: e.target.value || undefined })}><option value="">{t.izFree}</option>{(zones || []).map((z) => <option key={z.id} value={z.id}>{z.name}</option>)}</select></label>
    </div>
  );
}

export default function SprayFields({ t, obj, patch, zones }) {
  if (!isHead(obj)) return null;
  if (!isSprinkler(obj)) return <HeadExtra t={t} obj={obj} patch={patch} zones={zones} />;
  return (
    <div className="spray-fields" data-testid="spray-fields">
      <label>{t.spThrow}<input inputMode="decimal" data-testid="spray-throw-input" value={obj.throw ?? ''} placeholder={String(sprayR(obj)).replace('.', ',')} onChange={(e) => patch({ throw: e.target.value })} /></label>
      <label>{t.spArc}
        <select data-testid="spray-arc-select" value={sprayArc(obj)} onChange={(e) => patch({ arc: +e.target.value })}>
          {[360, 270, 180, 90].map((a) => <option key={a} value={a}>{t['spArc_' + a]}</option>)}
        </select>
      </label>
      {sprayArc(obj) < 360 && <label>{t.spDir}<input type="range" min="0" max="355" step="5" data-testid="spray-dir-input" value={+obj.dir || 0} onChange={(e) => patch({ dir: +e.target.value })} /><output>{+obj.dir || 0}°</output></label>}
      <HeadExtra t={t} obj={obj} patch={patch} zones={zones} />
    </div>
  );
}
